export const RESULT_PAGE_SHOW_MAP_CLICKED = 'RESULT_PAGE_SHOW_MAP_CLICKED';
export const RESULT_PAGE_SHOW_MAP_CLICKED_VERSION = '1.2';

export type ResultPageShowMapClickedPayload = {
  searchId: string;
  action: string;
};

export type ResultPageShowMapClickedParams = {
  searchId: string;
  action: string;
};

export const createResultPageShowMapClickedPayload = ({
  searchId,
  action,
}: ResultPageShowMapClickedParams): ResultPageShowMapClickedPayload => ({
  searchId,
  action,
});
